"use strict";

import Page from "./components/ReservationPage.jsx";

export const auth = true;
export const title = "i18n:reservationPage.pageTitle";
export const Component = Page;
